module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Barnsley in the 1800s")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The population of Barnsley district increased dramatically between 1801 (21,363) and 1911 (176,442) as the linen weaving, coal mining and glass making industries developed. In 1841, the population stood at 46,980 and there were 2,380 inhabited houses in the town itself (with 504 more by 1851).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early manufacturing in the district focused on wire and nails but this was overtaken by the linen trade, introduced in 1774 by William Wilson, a Quaker from Cheshire. Workers wove at home until invention of the power loom around 1842 which enabled one worker to operate four or six looms and saw a move to factory operations. However, the industry was soon superseded by coal mining and glass manufacture.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ardsley aerial view. (Courtesy of the Tasker Trust)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Mining had developed gradually from the late 1600s, and the earliest recorded explosion of gas in a coal mine was on 11 July 1672, resulting in the death of one man. It expanded rapidly with improvements in different means of transporting coal to markets. The Barnsley Canal opened c.1800 and its route, from the town centre to the Aire and Calder Navigation east of Wakefield with a branch north-west to Barnby Colliery, passed through many rich coalfields. New methods of road construction were pioneered by Thomas Telford and John Loudon McAdam, and Barnsley was connected eventually to the railway network in 1851.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ardsley, Stairfoot and Hoyle Mill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ardsley was originally an agricultural village, with farms, mills and quarries, within the parish of Darfield. The Dearne and Dove Canal, completed in 1804 and linked to the Barnsley Canal and South Yorkshire Navigation, facilitated growth during the Industrial Revolution. In 1801 the population of Ardsley was 401; this had nearly quadrupled to 1,528 by 1851, when the South Yorkshire Railway arrived at Stairfoot, then again to 6,000 by 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Linen was the first industry to take hold and this needed damp conditions for the flax. Others spread along the canal banks: collieries, tan yards, lime kilns, bleach works, tar distillery, brickworks and glassworks. Just over the border in Barnsley were Beevor Bobbin Works and Barnsley Brewery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The facilities in Ardsley increased with its population, being well served by pubs, churches and chapels. Some victims’ relations managed inns or beer-houses, which provided the focus for socialising; they are a useful landmark for locating addresses. There were more chapels than churches, but the main ceremonies of baptisms, weddings and funerals took place in Church of England premises: All Saints in Darfield, St Mary’s in Barnsley town centre, then Christ Church from 1841.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first school was provided because John Micklethwaite left £30 in 1753 (worth £57,560 today) for a schoolmaster. Ardsley National School opened in 1840 and was replaced in 1910 by the Board School. Kendray Fever (Isolation) Hospital opened in 1890; Stairfoot suffered a typhoid fever outbreak early November 1875. Burials were in churchyards until Barnsley Cemetery opened in 1861.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Three postcards with aerial views over Barnsley centre, the top two from Locke Park and the bottom one from Town End. (Author’s collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Doncaster to Saltersbrook Turnpike Road ran through the centre of these communities and its replacement by the dual carriageway, Doncaster Road, led to the destruction of many old properties. Workers’ cottages without bathrooms were considered slums and cleared in the 1930s and 1950s. Other historic buildings have been lost and Ardsley House was demolished in 2018, despite objections.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b8e9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter04.vue
// module id = 87
// module chunks = 0